import { forwardRef, useImperativeHandle, useRef } from "react";
import { IoMdClose } from "react-icons/io";
import { IoSearch } from "react-icons/io5";
import Loader from "react-loader-spinner";

import { cn } from "../../lib/utils";
import useStore from "../../store/search-store";

export const SearchInput = forwardRef(
  ({ placeholder = "Search by product name", className, isLoading }, ref) => {
    const { searchQuery, setSearchQuery } = useStore((state) => ({
      searchQuery: state.searchQuery,
      setSearchQuery: state.setSearchQuery,
    }));
    const searchRef = useRef(null);

    useImperativeHandle(ref, () => ({
      getValue: () => {
        return searchQuery;
      },
      focus: () => searchRef.current.focus(),
    }));

    const handleClear = () => {
      setSearchQuery("");
    };

    return (
      <div className={cn("relative", className)}>
        <div className="relative">
          <div className="text-muted-foreground absolute left-5 top-1/2 -translate-y-1/2">
            <IoSearch size={24} className="text-primary" />
          </div>

          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder={placeholder}
            className="h-12 w-full rounded-full bg-secondary bg-opacity-10 pl-12 pr-9 text-fontBackground placeholder-fontBackground placeholder:opacity-70 focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary"
            ref={searchRef}
            maxLength={40}
          />

          {(searchQuery.length > 0 || isLoading) && (
            <div className="absolute right-3 top-1/2 flex -translate-y-1/2 items-center">
              {isLoading ? (
                <Loader type="Oval" color="var(--color-primary)" height={30} width={30} />
              ) : (
                <button onClick={handleClear} aria-label="Clear search">
                  <IoMdClose size={24} className="text-primary" />
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    );
  },
);
